import { schedulesLocale } from 'modules/schedules/presentation/locale';
import schedulesRoutes from 'modules/schedules/presentation/routes';

const schedulesModule = {
  routes: schedulesRoutes,
  locale: schedulesLocale,
};

export default schedulesModule;
